/**
 * Created by vladislav on 29/05/2023
 */

cleverapps.NodeDebugCommands = {
    moveCell: {
        description: "Move cell",
        key: InputDispatcher.KEY.c,
        action: function (arrowKey) {
            let dx = 0, dy = 0;

            switch (arrowKey) {
                case InputDispatcher.KEY.left: dx -= 1; break;
                case InputDispatcher.KEY.right: dx += 1; break;
                case InputDispatcher.KEY.down: dy -= 1; break;
                case InputDispatcher.KEY.up: dy += 1; break;
            }

            if (this.debugSetParentCell) {
                this.debugSetParentCell(dx, dy);
            }
        }
    },
    zOrder: {
        description: "z order",
        key: InputDispatcher.KEY.z,
        action: function (arrowKey) {
            let delta = 0;

            switch (arrowKey) {
                case InputDispatcher.KEY.up: delta = 1; break;
                case InputDispatcher.KEY.down: delta = -1; break;
                default: return;
            }

            if (this.debugSetLocalZOrder) {
                this.debugSetLocalZOrder(delta);
            } else {
                this.setLocalZOrder(this.getLocalZOrder() + delta);
            }
        }
    },
    anchor: {
        description: "Anchor",
        noDisplayUpdate: true,
        filter: function () {
            if (typeof GroundedView !== "undefined" && this instanceof GroundedView) {
                return false;
            }

            return cleverapps.flags.keyboardAnchorsMode || this.debugEditUnitAnchorsMode;
        },
        action: function (arrowKey) {
            switch (arrowKey) {
                case InputDispatcher.KEY.left: (this.sprite || this).anchorX += 0.01; this.debugBorderDx += 0.01; break;
                case InputDispatcher.KEY.right: (this.sprite || this).anchorX -= 0.01; this.debugBorderDx -= 0.01; break;
                case InputDispatcher.KEY.down: this.anchorY += 0.01; this.debugBorderDy += 0.01; break;
                case InputDispatcher.KEY.up: this.anchorY -= 0.01; this.debugBorderDy -= 0.01; break;
            }

            console.log(`anchors: ${Math.floor((this.sprite || this).anchorX * 100) / 100} x ${Math.floor(this.anchorY * 100) / 100
            }\toffsets: ${Math.floor(this.debugBorderDx * 100) / 100} x ${Math.floor(this.debugBorderDy * 100) / 100}`);

            if (typeof UnitView === "undefined" || !(this instanceof UnitView)) {
                return;
            }

            const urls = Families[this.unit.code].units.map((data, stage) => {
                const res = UnitView.UnitIconJson({ code: this.unit.code, stage }) || UnitView.UnitIconFrame({ code: this.unit.code, stage });
                return { bundle: res.getBundleName(), key: res.key };
            });

            const bundleNames = [...new Set(urls.map((url) => url.bundle))];

            const onSuccess = () => {
                cleverapps.git.edit("anchors", {
                    code: this.unit.code,
                    stage: this.unit.stage,
                    anchorX: Math.floor((this.sprite || this).anchorX * 100) / 100,
                    anchorY: Math.floor(this.anchorY * 100) / 100,
                    urls
                });

                cleverapps.bundleLoader.deleteBundles(bundleNames);
            };

            cleverapps.bundleLoader.loadBundles(bundleNames, { onSuccess });
        }
    },
    rotate: {
        description: "Rotate",
        key: InputDispatcher.KEY.r,
        action: function (arrowKey) {
            let delta = 0;

            switch (arrowKey) {
                case InputDispatcher.KEY.down:
                case InputDispatcher.KEY.left: delta = -1; break;
                case InputDispatcher.KEY.up:
                case InputDispatcher.KEY.right: delta = +1; break;
            }

            if (this.debugSetRotation) {
                this.debugSetRotation(this.rotation + delta);
            } else {
                this.rotation += delta;
            }
        }
    },
    scale: {
        description: "Scale",
        key: InputDispatcher.KEY.s,
        action: function (arrowKey) {
            const valueToFixed = function (value) {
                return +(value).toFixed(2);
            };

            let scaleDeltaX = 0;
            let scaleDeltaY = 0;

            switch (arrowKey) {
                case InputDispatcher.KEY.up:
                case InputDispatcher.KEY.right:
                    scaleDeltaX = this.scaleX > 0 ? 0.05 : -0.05;
                    scaleDeltaY = this.scaleY > 0 ? 0.05 : -0.05;
                    break;
                case InputDispatcher.KEY.down:
                case InputDispatcher.KEY.left:
                    scaleDeltaX = this.scaleX > 0 ? -0.05 : 0.05;
                    scaleDeltaY = this.scaleY > 0 ? -0.05 : 0.05;
                    break;
            }

            if (this.debugSetScale) {
                this.debugSetScale(this.scaleX + scaleDeltaX, this.scaleY + scaleDeltaY);
            } else {
                this.scaleX = valueToFixed(this.scaleX + scaleDeltaX);
                this.scaleY = valueToFixed(this.scaleY + scaleDeltaY);
            }
        }
    },
    mirror: {
        description: "Mirror",
        key: InputDispatcher.KEY.m,
        action: function (arrowKey) {
            const valueToFixed = function (value) {
                return +(value).toFixed(2);
            };

            let scaleDeltaX = 0;
            let scaleDeltaY = 0;

            switch (arrowKey) {
                case InputDispatcher.KEY.up:
                case InputDispatcher.KEY.down:
                    scaleDeltaX = 0;
                    scaleDeltaY = -this.scaleY * 2;
                    break;
                case InputDispatcher.KEY.left:
                case InputDispatcher.KEY.right:
                    scaleDeltaX = -this.scaleX * 2;
                    scaleDeltaY = 0;
                    break;
            }

            if (this.debugSetScale) {
                this.debugSetScale(this.scaleX + scaleDeltaX, this.scaleY + scaleDeltaY);
            } else {
                this.scaleX = valueToFixed(this.scaleX + scaleDeltaX);
                this.scaleY = valueToFixed(this.scaleY + scaleDeltaY);
            }
        }
    },
    width: {
        description: "Width",
        key: InputDispatcher.KEY.w,
        filter: function () {
            return typeof EditorMap2dDecoratorView === "undefined" || !(this instanceof EditorMap2dDecoratorView);
        },
        action: function (arrowKey) {
            switch (arrowKey) {
                case InputDispatcher.KEY.up: this.width++; break;
                case InputDispatcher.KEY.down: this.width--; break;
            }
        }
    },
    height: {
        description: "Height",
        key: InputDispatcher.KEY.h,
        filter: function () {
            return typeof EditorMap2dDecoratorView === "undefined" || !(this instanceof EditorMap2dDecoratorView);
        },
        action: function (arrowKey) {
            switch (arrowKey) {
                case InputDispatcher.KEY.up: this.height++; break;
                case InputDispatcher.KEY.down: this.height--; break;
            }
        }
    },
    fontSize: {
        description: "Font size",
        key: InputDispatcher.KEY.f,
        filter: function () {
            return this instanceof cc.LabelTTF;
        },
        action: function (arrowKey) {
            switch (arrowKey) {
                case InputDispatcher.KEY.up: this.setFontSize(this.getFontSize() + 1); break;
                case InputDispatcher.KEY.down: this.setFontSize(this.getFontSize() - 1); break;
            }
        }
    },
    textDimensions: {
        description: "Text dimensions",
        key: InputDispatcher.KEY.d,
        filter: function () {
            return this instanceof cc.LabelTTF;
        },
        action: function (arrowKey) {
            const dim = this.getDimensions();
            switch (arrowKey) {
                case InputDispatcher.KEY.up: this.setDimensions(dim.width, dim.height + 1); break;
                case InputDispatcher.KEY.down: this.setDimensions(dim.width, dim.height - 1); break;
                case InputDispatcher.KEY.left: this.setDimensions(dim.width - 1, dim.height); break;
                case InputDispatcher.KEY.right: this.setDimensions(dim.width + 1, dim.height); break;
            }
        }
    },
    move: {
        description: "Move",
        key: undefined,
        action: function (arrowKey) {
            const step = cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.shift) ? 10 : 1;
            let dx = 0, dy = 0;

            switch (arrowKey) {
                case InputDispatcher.KEY.left: dx -= step; break;
                case InputDispatcher.KEY.right: dx += step; break;
                case InputDispatcher.KEY.down: dy -= step; break;
                case InputDispatcher.KEY.up: dy += step; break;
            }

            if (this.debugSetPosition) {
                this.debugSetPosition(this.x + dx, this.y + dy);
            } else {
                this.x += dx;
                this.y += dy;
                this.debugBorderDx += dx;
                this.debugBorderDy += dy;
            }

            if (typeof EditorUnitView !== "undefined" && this instanceof EditorUnitView && this.unit.findComponent(Multiple)) {
                const cellSize = cleverapps.styles.Map2dView.cell;
                const multiple = this.unit.findComponent(Multiple);
                const fakeUnit = Map2d.currentMap.fogs.getFakeUnits(this.unit.x, this.unit.y)[multiple.indexInCell];
                let shiftX = fakeUnit && fakeUnit.shiftX || 0;
                let shiftY = fakeUnit && fakeUnit.shiftY || 0;

                switch (arrowKey) {
                    case InputDispatcher.KEY.left: shiftX -= 2 / cellSize.width; shiftY += 2 / cellSize.width; break;
                    case InputDispatcher.KEY.right: shiftX += 2 / cellSize.width; shiftY -= 2 / cellSize.width; break;
                    case InputDispatcher.KEY.down: shiftX -= 2 / cellSize.height; shiftY -= 2 / cellSize.height; break;
                    case InputDispatcher.KEY.up: shiftX += 2 / cellSize.height; shiftY += 2 / cellSize.height; break;
                }

                shiftX = cleverapps.clamp(Math.round(100 * shiftX) / 100, -0.5, 0.5);
                shiftY = cleverapps.clamp(Math.round(100 * shiftY) / 100, -0.5, 0.5);
                Editor.currentEditor.doCommand("shiftMultiple", {
                    x: this.unit.x, y: this.unit.y, index: multiple.indexInCell, code: this.unit.code, stage: this.unit.stage, shiftX, shiftY
                });
            }
        }
    }
};
